<div class="content_text">
    <div class="ck-content" *ngIf="text.content && text.content.html" [innerHTML]="text.content['html']|safeHtml"></div>
</div>
